"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Underway = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var activity_1 = require("../../model/activity");
var service_1 = require("../../../library/base/service");
var Underway = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Underway, _super);
    function Underway() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '正在进行最新活动';
        _this.code = '101096';
        _this.desc = '正在进行最新活动';
        _this.requestParams = new activity_1.UnderwayRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Underway;
}(service_1.BaseService));
exports.Underway = Underway;
//# sourceMappingURL=underway.js.map